export default __webpack_public_path__ + "static/media/3.7a2c5074.png";